module.exports = __webpack_public_path__ + "media/20 as usual.4ba62836.mp3";